import { AmexIcon, CardIcon, DinersClubIcon, DiscoverIcon, MaestroIcon, MasterCardIcon, VisaIcon } from "@xola/icons";
import clsx from "clsx";
import React from "react";

export enum CreditCardServices {
    VISA = "visa",
}

const icons = [
    { name: /amex/i, icon: AmexIcon },
    { name: /american.*express/i, icon: AmexIcon },
    { name: /diners.*club/i, icon: DinersClubIcon },
    { name: /discover/i, icon: DiscoverIcon },
    { name: /maestro/i, icon: MaestroIcon },
    { name: /mastercard/i, icon: MasterCardIcon },
    { name: /visa/i, icon: VisaIcon },
];

const getIcon = (name: string) => {
    return icons.find((icon) => icon.name.test(name))?.icon ?? CardIcon;
};

interface CardIconProps {
    name: string;
    size?: string;
    className?: string;
}

export const CreditCardIcon = ({ name, size = "large", className, ...rest }: CardIconProps) => {
    const Icon = getIcon(name);
    return <Icon size={size} className={clsx(className)} {...rest} />;
};
